'use client';

import dynamic from 'next/dynamic';

const PathsDemo = dynamic(() => import('./index'));

export default PathsDemo;
